export default __webpack_public_path__ + "static/media/sparkleratnight.942d6a98.jpg";